/**
 * Keep algorithm in sync with server/lib/matchBookBoxCsvName.js
 */

export function norm(s) {
  return String(s || '')
    .normalize('NFKC')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .toLowerCase()
    .replace(/[\s&]/g, '');
}

function stripParenSegmentsToBase(name) {
  let s = String(name).trim();
  let prev;
  do {
    prev = s;
    s = s.replace(/\s*\([^()]+\)/g, '').trim();
  } while (s !== prev);
  return s;
}

function collectParenLeafSegments(name) {
  const out = [];
  const re = /\(([^()]+)\)/g;
  let m;
  while ((m = re.exec(name)) !== null) {
    out.push(m[1].trim());
  }
  return out;
}

const NORM_TO_CANONICAL = new Map([
  ['arcane', 'Arcane Society'],
  ['booksfordayscrate', 'BFDC'],
  ['litjoy', 'LitJoyCrate'],
  ['litjoycrate', 'LitJoyCrate'],
]);

/**
 * @param {string[]} canonicalNames
 * @param {string} rawCsv
 * @returns {string|null}
 */
export function matchCsvBookboxName(canonicalNames, rawCsv) {
  const csv = String(rawCsv || '')
    .normalize('NFKC')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/^["'“”]+|["'“”]+$/g, '')
    .trim();
  if (!csv) return null;

  const list = [...canonicalNames].map((n) =>
    String(n || '')
      .normalize('NFKC')
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .trim()
  );
  const lower = csv.toLowerCase();

  let hit = list.find((n) => n.toLowerCase() === lower);
  if (hit) return hit;

  const cm = csv.match(/\(([^)]+)\)/);
  if (cm) {
    const inner = cm[1].trim();
    hit = list.find((n) => n.toLowerCase() === inner.toLowerCase());
    if (hit) return hit;
  }

  const ncsv = norm(csv);
  hit = list.find((n) => norm(n) === ncsv);
  if (hit) return hit;

  const aliasTarget = NORM_TO_CANONICAL.get(ncsv);
  if (aliasTarget) {
    hit = list.find((n) => n === aliasTarget) || list.find((n) => n.toLowerCase() === aliasTarget.toLowerCase());
    if (hit) return hit;
  }

  for (const listName of list) {
    for (const seg of collectParenLeafSegments(listName)) {
      if (seg.toLowerCase() === lower) return listName;
    }
  }

  for (const listName of list) {
    const base = stripParenSegmentsToBase(listName);
    if (base && norm(base) === ncsv) return listName;
  }

  return null;
}
